import { useValidations } from "@sttedra_ui/framework";

import { searchValue } from "@/composables/_commons/helper.js";

const { required } = useValidations();

export default function (object = null) {
  return {
    items: [
      {
        field: "titulo",
        label: "Título",
        value: searchValue(object, "titulo"),
        rules: { required },
        classObj: ["col-12"],
      },
      {
        field: "guidWorkspace",
        label: "GUID",
        value: searchValue(object, "guidWorkspace"),
        rules: { required },
        properties: {
          disabled: object != null,
        },
        classObj: ["col-12", "guid-custom-input"],
      },
      {
        field: "descripcion",
        label: "Descripción",
        value: searchValue(object, "descripcion"),
        type: "textarea",
        classObj: ["col-12"],
      },
    ],
  };
}
